import { renderless, api } from "@opentiny/vue-renderless/checkbox/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import "@opentiny/vue-theme-mobile/checkbox/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  inheritAttrs: false,
  props: [].concat(props, ["modelValue", "text", "events", "label", "indeterminate", "disabled", "checked", "name", "trueLabel", "falseLabel", "id"]),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", {
    staticClass: "tiny-mobile-checkbox",
    class: {
      "is-disabled": _vm.state.isDisabled,
      "is-checked": _vm.state.isChecked,
      "is-indeterminate": _vm.indeterminate,
      "is-focus": _vm.state.focus
    },
    attrs: {
      "id": _vm.id
    }
  }, [_c("span", {
    staticClass: "tiny-mobile-checkbox__input",
    attrs: {
      "tabindex": _vm.indeterminate ? 0 : false,
      "role": _vm.indeterminate ? "checkbox" : false,
      "aria-checked": _vm.indeterminate ? "mixed" : false
    }
  }, [_c("span", {
    staticClass: "tiny-mobile-checkbox__inner"
  }), _vm.trueLabel || _vm.falseLabel ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.state.model,
      expression: "state.model"
    }],
    staticClass: "tiny-mobile-checkbox__original",
    attrs: {
      "type": "checkbox",
      "aria-hidden": _vm.indeterminate ? "true" : "false",
      "name": _vm.name,
      "disabled": _vm.state.isDisabled,
      "true-value": _vm.trueLabel,
      "false-value": _vm.falseLabel
    },
    domProps: {
      "checked": Array.isArray(_vm.state.model) ? _vm._i(_vm.state.model, null) > -1 : _vm._q(_vm.state.model, _vm.trueLabel)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.state.model, $$el = $event.target, $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel;
        if (Array.isArray($$a)) {
          var $$v = null, $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.state, "model", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.state, "model", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.state, "model", $$c);
        }
      }, _vm.handleChange],
      "focus": function focus($event) {
        _vm.state.focus = true;
      },
      "blur": function blur($event) {
        _vm.state.focus = false;
      }
    }
  }) : _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.state.model,
      expression: "state.model"
    }],
    staticClass: "tiny-mobile-checkbox__original",
    attrs: {
      "type": "checkbox",
      "aria-hidden": _vm.indeterminate ? "true" : "false",
      "disabled": _vm.state.isDisabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.label,
      "checked": Array.isArray(_vm.state.model) ? _vm._i(_vm.state.model, _vm.label) > -1 : _vm.state.model
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.state.model, $$el = $event.target, $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.label, $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.state, "model", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.state, "model", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.state, "model", $$c);
        }
      }, _vm.handleChange],
      "focus": function focus($event) {
        _vm.state.focus = true;
      },
      "blur": function blur($event) {
        _vm.state.focus = false;
      }
    }
  })]), _vm.slots.default && _vm.slots.default() || _vm.state.isShowText ? _c("span", {
    staticClass: "tiny-mobile-checkbox__label"
  }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.state.showText))];
  })], 2) : _vm._e()]);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobile = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobile as default
};
